module.exports = __webpack_public_path__ + "img/businessModelRed2.348fb845.jpg";